export const ADAPTIVE_LABEL = 'Adaptive Practice';
